export const THANK_YOU_ROUTE = "/beverage2/thank-you";

/**
 * Persists the guest's personalization consent choice and advances to the
 * thank-you page — but only once the save has actually succeeded.
 *
 * sessionStorage is intentionally NOT written, and navigate is intentionally
 * NOT called, until saveConsent resolves without throwing: this page is the
 * last step before thank-you, so a failed save here has no later chance to
 * bundle the consent value into another request the way V5/V6/V7 do. Writing
 * "responded" optimistically (or navigating regardless of outcome) would let
 * a failed save look handled locally while CDP never received it, with no
 * way to retry.
 *
 * @returns {{ saved: true } | { saved: false, error: unknown }}
 */
export const saveConsentAndContinue = async ({
  acid,
  optedOut,
  saveConsent,
  navigate,
  storage = sessionStorage,
}) => {
  try {
    await saveConsent(acid, optedOut);
  } catch (error) {
    return { saved: false, error };
  }

  storage.setItem("beverageConsentResponded", "true");
  storage.setItem("beverageConsentOptedOut", optedOut ? "true" : "false");
  navigate(THANK_YOU_ROUTE);

  return { saved: true };
};
